import React from 'react'
import ClickOutside from 'react-click-outside'

export default function ClickOutsideCustom(props) {
  const {avoidElementName} = props

  const onClickOutside = e => {
    if (avoidElementName) {
      const element = document.getElementById(avoidElementName)
      if (element && element.contains(e.target)) {
        return
      }
    }

    return props.onClickOutside && props.onClickOutside(e)
  }
  return <ClickOutside onClickOutside={onClickOutside}>{props.children}</ClickOutside>
}
